<div class="edition-modal-placeholder">
  <div class="placeholder-text"></div>
  <div class="placeholder-text placeholder-text__rating"></div>
  <div class="placeholder-modal-container">
    <div class="placeholder-modal-controllers"></div>
  </div>
  <div margin-top class="placeholder-text"></div>
</div>
